import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import * as authApi from '@api/auth';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [error, setError] = useState(token ? '' : 'This password reset link is invalid.');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    if (password !== confirmation) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);
    setError('');
    try {
      await authApi.resetPassword(token, password);
      navigate('/', { replace: true });
    } catch (err) {
      setError(err.status ? err.message : 'Network error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main style={{ display: 'grid', placeItems: 'center', flex: 1, padding: 24 }}>
      <form onSubmit={handleSubmit} style={{ width: '100%', maxWidth: 380, padding: 32, background: 'var(--bg-surface)', border: '1px solid var(--border)', borderRadius: 16 }}>
        <h1 style={{ marginBottom: 8, fontSize: 24, color: 'var(--text-primary)' }}>Choose a new password</h1>
        <p style={{ marginBottom: 24, color: 'var(--text-secondary)' }}>Your reset link is valid for one hour.</p>
        <input type="password" placeholder="New password" value={password} onChange={(event) => setPassword(event.target.value)} required minLength={6} style={{ width: '100%', padding: '12px 16px', marginBottom: 12, borderRadius: 8, border: '1px solid var(--border)', background: 'var(--bg-elevated)', color: 'var(--text-primary)', boxSizing: 'border-box' }} />
        <input type="password" placeholder="Confirm new password" value={confirmation} onChange={(event) => setConfirmation(event.target.value)} required minLength={6} style={{ width: '100%', padding: '12px 16px', marginBottom: 16, borderRadius: 8, border: '1px solid var(--border)', background: 'var(--bg-elevated)', color: 'var(--text-primary)', boxSizing: 'border-box' }} />
        <button type="submit" disabled={loading || !token} style={{ width: '100%', padding: 12, background: 'var(--accent)', color: 'var(--text-on-accent)', border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 600 }}>
          {loading ? 'Saving...' : 'Save new password'}
        </button>
        {error && <p style={{ marginTop: 12, color: 'var(--live-red)', fontSize: 14 }}>{error}</p>}
      </form>
    </main>
  );
}
